import { CONSENT_CATEGORY, type ConsentCategory, type ConsentMethod, type ConsentSnapshot } from '@/consent/contract';
import type { LinkieConsent } from '@/consent/types';

export const hasConsent = (category: ConsentCategory): boolean =>
  window.linkieConsent?.get(category) ?? category === CONSENT_CATEGORY.NECESSARY;

export const setConsent = (categories: Parameters<LinkieConsent['set']>[0], via: ConsentMethod): void =>
  window.linkieConsent?.set(categories, via);

export const consentSnapshot = (): ConsentSnapshot | null => window.linkieConsent?.getSnapshot() ?? null;

export const onConsentChange = (listener: (snapshot: ConsentSnapshot | null) => void): (() => void) =>
  window.linkieConsent?.on(listener) ?? (() => {});

export const configureConsent = (config: Parameters<LinkieConsent['configure']>[0]): void =>
  window.linkieConsent?.configure(config);

export const markConsentActivated = (category: ConsentCategory): void => window.linkieConsent?.markActivated(category);

export const openConsentPreferences = (): void => window.linkieConsent?.openPreferences();
